const cce = {
  MICRO_DEPOSIT_NOT_ALLOWED: {
    message: 'Micro deposit is not allowed for your account',
    field: 'type',
    code: 'CCE_1'
  },
  MICRO_DEPOSIT_VALUE_NOT_ALLOWED: {
    message: 'Specify the micro deposit value is not allowed for your account',
    field: 'type',
    code: 'CCE_2'
  },
  DESCRIPTION_ALLOWED_ONLY_FOR_PIX: {
    message: 'Description is only allowed in Pix validations',
    field: 'pix_description',
    code: 'CCE_3'
  },
  INVALID_DESCRIPTION_LENGTH: {
    message: 'Pix description can not be greater than 140 characters',
    field: 'pix_description',
    code: 'CCE_4'
  },
  INVALID_DESCRIPTION_FORMAT: {
    message: 'Pix description format is not allowed',
    field: 'pix_description',
    code: 'CCE_5'
  },
  BASIC_VALIDATION_NOT_ALLOWED: {
    message: 'Basic validation is not allowed for your account',
    field: 'type',
    code: 'CCE_6'
  },
  MICRO_DEPOSIT_VALIDATION_RATE_LIMIT_EXCEEDED: {
    message: 'Micro deposit validation limit exceeded for this bank account or Pix key',
    code: 'CCE_7'
  }
};

module.exports = cce;
